import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import { useHistory } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import { useFirebaseApp } from "reactfire";
import Logo from "../../Assets/img/LOGO-BABY-PANDA.svg";

const useStyles = makeStyles((theme) => ({
  root: { height: "100vh" },
  paper: {
    margin: theme.spacing(8, 4),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  form: { width: "60%", marginTop: theme.spacing(1) },
  submit: { margin: theme.spacing(3, 0, 2), backgroundColor: "#E59366" },
}));

export default function Login() {
  const [emailstate, setEmail] = useState("");
  const [passwordstate, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState(""); // Estado para el error

  let fb = useFirebaseApp();
  let History = useHistory();
  const classes = useStyles();

  const SignIn = () => {
    setErrorMessage(""); // Limpia el error previo

    fb.auth()
      .signInWithEmailAndPassword(emailstate, passwordstate)
      .then(() => History.push("/"))
      .catch(() =>
        setErrorMessage(
          "⚠️ Correo o contraseña incorrectos. Verifica tus datos."
        )
      );
  };

  return (
    <Grid container component="main" className={classes.root}>
      <CssBaseline />
      <Grid item xs={12} sm={12} md={12} component={Paper} elevation={6} square>
        <div className={classes.paper}>
          <img
            style={{ width: "350px", height: "auto" }}
            src={Logo}
            alt="logo"
          />
          <form className={classes.form} noValidate>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              label="Correo electrónico"
              autoComplete="email"
              autoFocus
              onChange={(e) => setEmail(e.target.value)}
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              label="Contraseña"
              type="password"
              autoComplete="current-password"
              onChange={(e) => setPassword(e.target.value)}
            />

            {errorMessage && ( // Muestra el mensaje de error si existe
              <Typography color="error" variant="body2" align="center">
                {errorMessage}
              </Typography>
            )}

            <Button
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
              onClick={SignIn}
            >
              Entrar
            </Button>
            <Button
              fullWidth
              variant="text"
              style={{
                marginTop: "8px",
                color: "#E59366",
                textTransform: "none",
              }}
              onClick={() => {
                window.open(
                  "https://wa.me/573186889088?text=Hola%20B%C3%BAbobox%2C%20olvid%C3%A9%20mi%20contrase%C3%B1a%20de%20Backoffice.babypandaco.com.",
                  "_blank"
                );
              }}
            >
              ¿Olvidaste tu contraseña?
            </Button>
          </form>
        </div>
      </Grid>
    </Grid>
  );
}
